module.exports = __webpack_public_path__ + "static/media/016.b792f70b.jpg";